import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import 'rxjs/add/operator/filter';

import { LocaleService } from '../locale/locale.service';
import { User } from '../user/user.model';
import { UserService } from '../user/user.service';
import { Observable } from '../util/rxjs';

import { MenuRoute, MenuRouteChild, menuRoutes } from './client-route';

@Component({
  selector: 'cp-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavComponent implements OnInit {
  user$: Observable<User>;
  locale$: Observable<string>;
  menuItems: MenuRoute[];
  subMenuItems?: MenuRouteChild[];

  languages = ['en', 'de', 'ja', 'es', 'fr', 'hu', 'zh-Hans'];

  constructor(
    private router: Router,
    private userService: UserService,
    private localeService: LocaleService,
    private cd: ChangeDetectorRef
  ) {
    this.menuItems = menuRoutes;
    this.user$ = userService.user$;
    this.locale$ = localeService.locale$;
  }

  ngOnInit() {
    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      const activeLink = this.menuItems.find(item =>
        this.router.isActive(item.matchUrl.join('/'), false)
      );
      this.subMenuItems = activeLink && activeLink.children;
      this.cd.detectChanges();
    });
  }

  logout() {
    this.userService.logout().subscribe(() => this.logoutUI(), () => this.logoutUI());
  }

  setLocale(locale: string) {
    this.localeService.setLocale(locale);
  }

  private logoutUI() {
    this.userService.setAnonymous();
    this.router.navigate(['/login']);
  }
}
